import { Layout } from "antd";
import Navigation from "../components/Navigation";
const { Header, Sider, Content } = Layout;

const SidebarLayout = ({ children }) => {
  return (
    <Layout>
      <Header className="header" style={{ zIndex: 101 }}>
        <div className="header-content">
          <Navigation withBrand={true} />
        </div>
      </Header>
      <Layout>{children}</Layout>
    </Layout>
  );
};

const SidebarContent = ({ style, children }) => {
  return (
    <Layout className="sidebar-layout-content" style={style}>
      <Content className="collapse">{children}</Content>
    </Layout>
  );
};

const Sidebar = ({ children }) => {
  return (
    <Sider
      breakpoint="sm"
      collapsedWidth="0"
      theme="light"
      className="sidebar"
      width={280}
      style={{ zIndex: 100 }}
    >
      <div style={{ padding: "20px" }}>{children}</div>
    </Sider>
  );
};

SidebarLayout.Content = SidebarContent;
SidebarLayout.Sidebar = Sidebar;

export default SidebarLayout;
